import React from 'react';
import { Tabs } from 'antd';
import { BackOfficeProjectTemplates } from './BackOfficeProjectTemplates';
import { BackOfficePreInvoices } from './BackOfficePreInvoices';
import { useHistory } from 'react-router';
import { history } from '../../../../redux/store';

function useGetActiveTab() {
  const { location } = useHistory();

  const search = location.search;

  const activeTab = search.split('=')?.[1];

  if (['contracts', 'proforma'].includes(activeTab)) return activeTab;

  return 'contracts';
}

function BackOfficeInvoice() {
  const activeTab = useGetActiveTab();

  const items = [
    {
      key: 'contracts',
      label: 'Project Contracts',
      children: <BackOfficeProjectTemplates />,
    },
    {
      key: 'proforma',
      label: 'Proforma Invoices',
      children: <BackOfficePreInvoices />,
    },
  ];

  return (
    <Tabs
      style={{ padding: 0 }}
      tabBarStyle={{
        background: '#fff',
        paddingInline: 24,
        margin: 0,
        borderTop: '1px solid #f2f2f2',
      }}
      items={items}
      activeKey={activeTab}
      onChange={(activeKey) => {
        history.push(`/back-office/invoice/?tab=${activeKey}`);
      }}
      defaultActiveKey="contracts"
    />
  );
}

export default BackOfficeInvoice;
